import { COLOR_BASE_GREY_30, COLOR_BASE_GREY_60, COLOR_BASE_GREY_80 } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';

export const StyledPopover = styled.div`
	.popover--trigger {
		display: flex;
		align-items: center;
		color: ${COLOR_BASE_GREY_80};
		font-family: AudiType, sans-serif;

		& .icon {
			color: ${COLOR_BASE_GREY_60};
		}
	}

	.popover--root {
		padding: 24px 12px;
		// background: ${COLOR_BASE_GREY_80};
		// color: ${COLOR_BASE_GREY_30};
	}

	.popover--body {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
`;

export const PopoverContentStyle = styled.div<{ $show: boolean }>`
	display: flex;
	flex-direction: column;
	padding: 24px 12px;
	gap: 12px;
	pointer-events: all;
	background: white;
	filter: drop-shadow(rgba(0, 0, 0, 0.04) 0px 10px 8px) drop-shadow(rgba(0, 0, 0, 0.1) 0px 4px 3px);
	opacity: ${(props) => (props.$show ? 1 : 0)};
	position: absolute;
	top: 24px;
	left: 0;
	width: 100%;
	pointer-events: all;
	z-index: ${(props) => (props.$show ? 1999 : 0)};
	visibility: ${(props) => (props.$show ? 'visible' : 'hidden')};
`;
